import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, Float32Field, BooleanField, Int32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class ModulationBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new ModulationBox({
            uuid,
            graph,
            name: "ModulationBox",
            pointerRules: {
                accepts: [Pointers.Selection],
                mandatory: false,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "ModulationBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({});
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitModulationBox, this);
    }
    get tags() {
        return ModulationBox.Tags;
    }
    get source() {
        return this.getField(1);
    }
    get target() {
        return this.getField(2);
    }
    get depth() {
        return this.getField(3);
    }
    get enabled() {
        return this.getField(4);
    }
    get index() {
        return this.getField(5);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "source",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.ModulatorSource, true),
            2: PointerField.create({
                parent: this,
                fieldKey: 2,
                fieldName: "target",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.Modulation, true),
            3: Float32Field.create({
                parent: this,
                fieldKey: 3,
                fieldName: "depth",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, "bipolar", "%", 0),
            4: BooleanField.create({
                parent: this,
                fieldKey: 4,
                fieldName: "enabled",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
            5: Int32Field.create({
                parent: this,
                fieldKey: 5,
                fieldName: "index",
                deprecated: false,
                pointerRules: NoPointers,
            }, "index", ""),
        };
    }
}
